export const AppRoutes = {
  // Home
  home: "/",

  // Login
  login: "/login",
  authCallback: "/auth/callback",
  recover: "/recover",
  recoverComplete: "/recover-complete",
  resetPassword: "/reset-password",
  resetPasswordComplete: "/reset-password-complete",
  register: "/register",
  registerComplete: "/register-complete",
  confirmEmail: "/user-setting/confirm-email",

  // Information
  information: "/information",
  informationDetail: "/information/:id",

  // User Setting
  userSettingDetail: "/user-setting/detail",
  userSettingEdit: "/user-setting/edit",
  userSettingChangeEmail: "/user-setting/change-email",

  // company
  companyList: "/company",
  companyCreate: "/company/create",
  companyDetail: "/company/:companyId/detail",
  companyEdit: "/company/:companyId/edit",
  companyImport: "/company/import",

  // Contact
  contact: "/contact",

  // Talent
  talentList: "/talent",
  talentCreate: "/talent/create",
  talentDetail: "/talent/:talentId/detail",
  talentEdit: "/talent/:talentId/edit",
  talentImport: "/talent/import",

  // Job
  jobList: "/job",
  jobCreate: "/job/create",
  jobDetail: "/job/:jobId/detail",
  jobEdit: "/job/:jobId/edit",
  jobImport: "/job/import",

  // Partner
  partnerList: "/partner",
  partnerCreate: "/partner/create",
  partnerDetail: "/partner/:partnerId/detail",
  partnerEdit: "/partner/:partnerId/edit",
  partnerImport: "/partner/import",

  // Case
  caseList: "/cases",
  caseCreate: "/job/:jobId/case/create",
  caseDetail: "/job/:jobId/case/:caseId/detail",
  caseEdit: "/job/:jobId/case/:caseId/edit",

  // Dashboard
  offerAcceptedList: "/offer-accepted",
  performanceDetail: "/performance-detail",

  // page not found
  pageNotFound: "/page-not-found",
  serverErrorPage: "/server-error",

  // Maintenance
  maintenance: "/maintenance",

  // Match
  match: "/match",
  matchEdit: "/match/edit",

  // Business Report
  businessReport: "/business-report",

  // Management Ledger
  managementLedger: "/management-ledger",

  // Shared (public, no auth required)
  sharedPassword: "/shared/:hash",
  sharedDetail: "/shared/:hash/detail",
};

export const LoginRoutes = [
  AppRoutes.login,
  AppRoutes.authCallback,
  AppRoutes.recover,
  AppRoutes.resetPassword,
  AppRoutes.register,
  AppRoutes.confirmEmail,
];

// Guest-only pages: an authenticated user is redirected home by `withGuest`.
// `confirmEmail` is intentionally excluded — it is opened from an email link by
// users who are usually already logged in.
export const GuestRoutes = [AppRoutes.login, AppRoutes.recover, AppRoutes.resetPassword, AppRoutes.register];

export const TalentRoutes = [AppRoutes.talentList, AppRoutes.talentCreate, AppRoutes.talentDetail, AppRoutes.talentEdit, AppRoutes.talentImport];

export const CompanyRoutes = [AppRoutes.companyList, AppRoutes.companyCreate, AppRoutes.companyDetail, AppRoutes.companyEdit];

export const UserSettingRoutes = [AppRoutes.userSettingDetail, AppRoutes.userSettingEdit, AppRoutes.userSettingChangeEmail];

export const ClientRoutes = [AppRoutes.home, AppRoutes.talentList].flat();

export const MatchRoutes = [AppRoutes.match, AppRoutes.matchEdit];

export const JobRoutes = [AppRoutes.jobList, AppRoutes.jobCreate, AppRoutes.jobEdit, AppRoutes.jobDetail, AppRoutes.jobImport];

export const PartnerRoutes = [
  AppRoutes.partnerList,
  AppRoutes.partnerCreate,
  AppRoutes.partnerDetail,
  AppRoutes.partnerEdit,
  AppRoutes.partnerImport,
];

export const CasesRoutes = [AppRoutes.caseList, AppRoutes.caseCreate, AppRoutes.caseDetail, AppRoutes.caseEdit];

export const BusinessReportRoutes = [AppRoutes.businessReport];

export const ManagementLedgerRoutes = [AppRoutes.managementLedger];
